{
  "Domain": "Dominio:",
  "EmailServerConnectivity": "Connettività del server e-mail",
  "ServerIpAddress": "Indirizzo IP del server:",
  "TcpPort": "Porta TCP:",
  "CommunicationActive": "Comunicazione attiva:",
  "FromAddressEmail": "Indirizzo (e-mail):",
  "FromAddressName": "Da Indirizzo (Nome):",
  "CompanyName": "Nome della società:",
  "UseAuthentication": "Utilizzare l'autenticazione:",
  "AuthenticationSettings": "Impostazioni di autenticazione",
  "DomainProfile_ButtonHelpLabel": "Aiuto?",
  "DomainProfile_ButtonSubmitLabel": "OK",
  "DomainProfile_ButtonCancelLabel": "Annullamento",
  "DomainProfile_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "DomainProfile_PromptConfirm": "Sì",
  "DomainProfile_PromptCancel": "Annullamento",
  "DomainProfile_Username": "Nome utente:",
  "DomainProfile_Password": "Password:",
  "DomainProfile_PasswordPlaceholder": "------",
  "NAME": "DomainProfile",
  "CustomDownloadLinks": "Link per download personalizzati",
  "MSTeamsAppDownloadLinkURLName": "URL per il download dell'app MS Teams:",
  "CXIClientDownloadLinkWindowsUrlName": "URL del client CXI (Windows):",
  "CXIClientDownloadLinkMacUrlName": "URL del client CXI (Mac):",
  "SearchAndCallDownloadLinkURLName": "Cerca e chiama URL:",
  "AccessCodes": "Codici di accesso",
  "CXIAccessCode": "Codice di accesso CXI:"
}